export const CREATE_AGENT = "CREATE_AGENT";
export const UPDATE_AGENT = "UPDATE_AGENT";
export const DELETE_AGENT = "DELETE_AGENT";
export const FETCH_AGENTS = "FETCH_AGENTS";
export const LISTEN_TO_SELECTED_AGENT = "LISTEN_TO_SELECTED_AGENT";
